import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GetCallHistoryAction} from '../../call-history.actions';
import {CallHistoryCall, CallHistorySearchParams} from '../../call-history-params.interface';
import {Store} from '@ngrx/store';
import {IState} from '../../../shared/models/state';
import * as moment from 'moment';
import {getCallHistoryPageSelector} from '../../call-history.reducer';
import {MatTableDataSource} from '@angular/material/table';
import {getCallMode} from '../../../shared/utils/call-type-mode';

@Component({
  selector: 'cc-calls-table',
  templateUrl: './calls-table.component.html',
  styleUrls: ['./calls-table.component.scss']
})
export class CallsTableComponent implements OnInit {
  public getCallingMode = getCallMode;
  @Input() filters: CallHistorySearchParams;
  @Input() displayedColumns: string[];
  @Input() sort: string;
  @Input() dataSource: MatTableDataSource<CallHistoryCall>;
  @Output() detailsClicked = new EventEmitter<number>();
  public detailsInfo: any;

  constructor(private store: Store<IState>) {}

  ngOnInit() {
    this.store.select(getCallHistoryPageSelector).subscribe(params => {
      this.filters = params;
    });
    this.displayedColumns = [...this.displayedColumns, 'detailsInfo'];
  }

  sortChange($event: { active; direction }) {
    this.filters.order = $event.direction ? $event.direction.toUpperCase() : null;
    this.filters.sortBy = $event.active;
    this.store.dispatch(new GetCallHistoryAction(this.filters));
  }

  getNamePhrase(name: string, surname: string) {
    return name || surname ? `${name}${surname ? ' ' + surname : ''}` : null;
  }

  formatCallLength(callLength: number) {
    const minutes = Math.floor(callLength / 60);
    const seconds = callLength - minutes * 60;
    return { minutes: minutes, seconds: seconds };
  }

  formatDate(date: string) {
    return moment(date).format('LT, l');
  }

  arrowIconDirector(event) {
    if (!event.answered && event.direction === 'OUTBOUND') {
      return 'call_missed_outgoing';
    } else if (!event.answered && event.direction === 'INBOUND') {
      return 'call_missed';
    } else if (event.answered && event.direction === 'OUTBOUND') {
      return 'call_made';
    } else if (event.answered && event.direction === 'INBOUND') {
      return 'call_received';
    }
  }

  isCallMissed(element) {
    return (
      this.arrowIconDirector(element) === 'call_missed' || this.arrowIconDirector(element) === 'call_missed_outgoing'
    );
  }

}
